import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { getType } from 'mobx-state-tree';
import { useStore } from '@mcn-platform/models';
import Image from '../aws/Image';
import SignedImage from '../aws/SignedImage';
/**
 * Implements a preview of an Asset.  For images this is a thumb, for videos it
 * is a key frame.  For other types it might be an icon or something similar.
 * @param asset to preview.
 * @returns JSX component
 */
const AssetImage = ({ asset, className, size, avatar, avatarVariant, customStyle, fallbackSrc, }) => {
    const store = useStore();
    const [url, setUrl] = useState((asset?.getPrecachedUrl && asset?.getPrecachedUrl(size || '')) || '');
    useEffect(() => {
        if (asset?.syncState !== 'loaded' || !size) {
            return;
        }
        (async () => {
            // console.log('AssetImage with', asset);
            // console.log('   type of', getType(asset));
            if (getType(asset).name !== 'Asset') {
                // console.error('AssetImage called with non asset type', asset);
                setUrl(fallbackSrc || '');
                // throw new Error(`Doesnt appear to be a valid asset ${asset.id}`);
                return;
            }
            if (asset.type === 'application' || asset.type === 'pdf') {
                const { url: newUrl /* expiry: newExpiry */ } = await asset.getSignedUrl('preview.png');
                setUrl(newUrl);
                return;
            }
            if (asset.type !== 'image' && asset.type !== 'video') {
                // console.error('AssetImage called with non asset type', asset);
                setUrl(fallbackSrc || '');
                // throw new Error(`Doesnt appear to be a valid asset ${asset.id}`);
                return;
            }
            const { url: newUrl /* expiry: newExpiry */ } = await asset.getSignedUrl(size);
            setUrl(newUrl);
        })();
    }, [asset, asset?.syncState, fallbackSrc, size, store]);
    if (!asset || !url) {
        return (_jsx(SignedImage, { bucket: "", bucketKey: "", status: "", alt: "", className: className, avatar: avatar, avatarVariant: avatarVariant, customStyle: customStyle, fallbackSrc: fallbackSrc }));
    }
    return (_jsx(Image
    // todo - need to make it work with thumb or original
    , { 
        // todo - need to make it work with thumb or original
        url: url, status: asset.status, alt: asset.name, className: className, avatar: avatar, avatarVariant: avatarVariant, customStyle: customStyle, backgroundColor: asset.dominantColor, fallbackSrc: fallbackSrc, updatedAt: asset.updatedAt }));
};
AssetImage.defaultProps = {
    className: '',
    avatar: false,
    avatarVariant: 'circular',
    customStyle: {},
    fallbackSrc: undefined,
};
AssetImage.getData = async ({ asset, size, }, store) => {
    // console.log('Adding background image to preload', backgroundImage.assetId);
    if (asset && size) {
        console.log('load asset', asset.key);
        await store.load('asset', asset.key);
        await store.load('repository', asset.repository?.key);
        await asset.getSignedUrl(size);
    }
    return Promise.resolve('ok');
};
export default observer(AssetImage);
//# sourceMappingURL=AssetImage.js.map